import { render, staticRenderFns } from "./MaterialTypesSettingsOverviewPage.vue?vue&type=template&id=74cb3da4"
import script from "./MaterialTypesSettingsOverviewPage.vue?vue&type=script&lang=js"
export * from "./MaterialTypesSettingsOverviewPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports